import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'
import { useImage } from './useImage'

export default function Image(props) {
  const {
    src,
    srcMobile,
    srcTablet,
    alt,
    fallback,
    ariaHidden,
    lazy,
    webp,
    gtm = { className: '' },
    ...rest
  } = props

  const imageRef = React.useRef(null)
  const { config, style, handleImageLoaded, resizeComponent, getImagetype } =
    useImage()
  const className = resolveProps(props, config, 'Image').replace(
    /proportion-/g,
    ''
  )
  const proportion = className.replace(/mdn-Image ?/, '').replace(/ /, '')
  const fixedProps = clearProps(rest)
  const type = getImagetype(src)

  const hasProportion = Object.keys(props).find((it) =>
    config.modifiers.includes(it)
  )

  return (
    <picture
      {...fixedProps}
      aria-hidden={!!ariaHidden}
      ref={imageRef}
      style={
        !!hasProportion
          ? {
              width: style.width,
              height: style.height
            }
          : {}
      }
      className={className}
    >
      {webp ? (
        <>
          <source
            srcSet={webp.srcSetMobileWebp}
            media="(max-width: 768px)"
            type="image/webp"
            {...gtm}
            className={`mdn-Image-asset ${gtm.className}`}
          />
          <source
            srcSet={webp.srcSetTabletWebp}
            media="(max-width: 991px)"
            type="image/webp"
            {...gtm}
            className={`mdn-Image-asset ${gtm.className}`}
          />
        </>
      ) : (
        ''
      )}
      <source
        srcSet={srcMobile || src}
        media="(max-width: 768px)"
        type={type}
        {...gtm}
        className={`mdn-Image-asset ${gtm.className}`}
      />
      <source
        srcSet={srcTablet || src}
        media="(max-width: 991px)"
        type={type}
        {...gtm}
        className={`mdn-Image-asset ${gtm.className}`}
      />

      <img
        src={src}
        alt={alt}
        onLoad={(event) => handleImageLoaded(event, proportion)}
        loading={lazy ? 'lazy' : 'eager'}
        type={type}
        {...gtm}
        className={`mdn-Image-asset ${gtm.className}`}
      />
    </picture>
  )
}

Image.propTypes = {
  src: PropTypes.string.isRequired,
  fallback: PropTypes.string,
  srcMobile: PropTypes.string,
  srcTablet: PropTypes.string,
  alt: PropTypes.string.isRequired,
  data: PropTypes.object,
  lazy: PropTypes.bool,
  ariaHidden: PropTypes.bool,
  webp: PropTypes.shape({
    srcSetMobileWebp: PropTypes.string,
    srcSetTabletWebp: PropTypes.string
  }),
  'proportion-3-2': PropTypes.bool,
  'proportion-1-1': PropTypes.bool,
  'proportion-3-4': PropTypes.bool,
  'proportion-1-2': PropTypes.bool
}
